import { Card } from './Card'

interface KpiCardProps {
  value: string | number
  label: string
  onClick?: () => void
}

export function KpiCard({ value, label, onClick }: KpiCardProps) {
  return (
    <Card className="kpi-card" onClick={onClick}>
      <div className="kpi-value">{value}</div>
      <div className="kpi-label">{label}</div>
    </Card>
  )
}